import { minus } from "@/math/coordinates";
import type { Board } from "@/model/board";
import type { RelativeCoordinate, SizedRectangle } from "@/model/coordinates";
import { halfCardSize } from "@/store/board";

export type RelativeCardRect = SizedRectangle<RelativeCoordinate> & { id: string };

export function getRelativeCardRects(board: Board): RelativeCardRect[] {
  // TODO using the DOM is not very stable, can we get rid of it and just use store data?
  const elements = document.querySelectorAll<HTMLDivElement>(".board > .sticky-note");

  const res = new Array<RelativeCardRect & { order: number }>();
  const halfCard = halfCardSize();
  elements.forEach((el) => {
    const id = el.getAttribute("id")!;
    const zIndex = parseInt(el.style.zIndex);
    const card = board.cards[id];
    res.push({
      id: card.data.id,
      p0: minus(card.meta.pos, halfCard),
      size: board.cardSize,
      order: zIndex || card.meta.zIndex,
    });
  });

  return res.sort((a, b) => a.order - b.order);
}
